import Button from '@components/common/Button';
import { SITE_INFO, DATA_PATHS, SOCIAL_LINKS } from '@lib/constants';

const HeroSection = () => {
  return (
    <section className="relative overflow-hidden py-20 sm:py-24 lg:py-32 px-4 sm:px-6 lg:px-8">
      {/* Subtle gradient background */}
      <div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(to bottom right, var(--color-theme-1), var(--color-theme-2))'
        }}
      >
        {/* Subtle ambient shapes */}
        <div
          className="absolute top-0 -left-4 w-96 h-96 rounded-full mix-blend-multiply filter blur-3xl opacity-20"
          style={{ backgroundColor: 'var(--color-accent-2)' }}
        ></div>
        <div
          className="absolute -bottom-8 right-0 w-96 h-96 rounded-full mix-blend-multiply filter blur-3xl opacity-10"
          style={{ backgroundColor: 'var(--color-accent-3)' }}
        ></div>
      </div>

      <div className="container mx-auto relative z-10 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Profile Picture */}
          <div className="flex justify-center order-2 md:order-1">
            <div className="relative">
              <div
                className="relative rounded-2xl p-1.5 shadow-card-hover"
                style={{
                  backgroundColor: 'var(--color-card-bg)',
                  borderColor: 'var(--color-border-light)',
                  borderWidth: '1px',
                  borderStyle: 'solid'
                }}
              >
                <img
                  src={DATA_PATHS.PROFILE_PICTURE}
                  alt="Srihaan Poddar"
                  className="relative w-80 h-80 rounded-xl object-cover"
                />
              </div>
            </div>
          </div>

          {/* Hero Content */}
          <div className="text-left order-1 md:order-2 space-y-6 sm:space-y-8">
            <div className="space-y-3 sm:space-y-4">
              <h1
                className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-heading font-extrabold tracking-tight"
                style={{ color: 'var(--color-heading)' }}
              >
                {SITE_INFO.name}
              </h1>
              <p
                className="text-lg sm:text-xl md:text-2xl font-semibold"
                style={{ color: 'var(--color-subheading)' }}
              >
                {SITE_INFO.tagline}
              </p>
            </div>

            <p
              className="text-base sm:text-lg leading-relaxed max-w-2xl"
              style={{ color: 'var(--color-subtle)' }}
            >
              As a senior at the International School Manila, I am deeply passionate about leveraging robotics and AI to solving real-world problems through engineering innovation. I believe in promoting inclusion and growth in community. Through research, leadership in robotics, and chess, I've learned to approach challenges with analytical precision and empathy-driven design.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-start pt-2">
              <a
                href="/contact"
                className="w-full sm:w-auto inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 px-6 py-3 text-lg shadow-card hover:shadow-card-hover"
                style={{
                  backgroundColor: 'var(--color-button-primary-bg)',
                  color: 'var(--color-button-primary-text)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = 'var(--color-button-primary-hover)';
                  e.currentTarget.style.transform = 'translateY(-1px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'var(--color-button-primary-bg)';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                Get in Touch
              </a>
              <a
                href={DATA_PATHS.CV}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full sm:w-auto inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 px-6 py-3 text-lg hover:shadow-card"
                style={{
                  borderColor: 'var(--color-button-outline-border)',
                  color: 'var(--color-button-outline-text)',
                  borderWidth: '1.5px',
                  borderStyle: 'solid',
                  backgroundColor: 'transparent'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = 'var(--color-button-outline-hover-bg)';
                  e.currentTarget.style.transform = 'translateY(-1px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                Download CV
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
